import { CurrentUser } from '../user/currentUser';
import { GetAccountStateError } from "./Errors/GetAccountStateError";
import { GetSubscriptionStateError } from "./Errors/GetSubscriptionStateError";
import { GetActiveStateError } from "./Errors/GetActiveStateError";
import { SetAccountStateError } from "./Errors/SetAccountStateError";
import { SaveNewUserOnNotificationsError } from "./Errors/SaveNewUserOnNotificationsError";
import { NotificationsApi } from "@scorewarrior/rubens_web_lib/lib/notifications/notifications-api";
import { Url } from "../url";
import { ICheckAccountResponse } from "@scorewarrior/rubens_web_lib/lib/notifications/protocols/check-user";
import { IChangeAccountStateResponse } from "@scorewarrior/rubens_web_lib/lib/notifications/protocols/change-account-state";
import { IAddNewAccountResponse } from "@scorewarrior/rubens_web_lib/lib/notifications/protocols/add-user";
import * as braze from '@braze/web-sdk';


export class WebpushServiceApi {
    static async saveUserToken(token: string): Promise<IAddNewAccountResponse> {
        try {
            const currentUser = CurrentUser.getInstance();
            const requestData = {
                platform: window.app.config.user_browser.name,
                signature: currentUser.getAuthToken(),
                suid: currentUser.getSuid(),
                token: token
            };
            const notificationsApi = new NotificationsApi(Url.getNotificationsServiceUrl());

            return await notificationsApi.addUser(requestData);
        } catch (exception) {
            throw new SaveNewUserOnNotificationsError(exception.message, exception.stack);
        }
    }

    static async setAccountState(state: boolean): Promise<IChangeAccountStateResponse> {
        try {
            const currentUser = CurrentUser.getInstance();
            const requestData = {
                platform: window.app.config.user_browser.name,
                signature: currentUser.getAuthToken(),
                suid: currentUser.getSuid(),
                state: state
            };
            const notificationsApi = new NotificationsApi(Url.getNotificationsServiceUrl());

            return await notificationsApi.changeAccountState(requestData);
        } catch (exception) {
            throw new SetAccountStateError(exception.message, exception.stack);
        }
    }

    static async isActiveAccount(): Promise<boolean> {
        try {
            const state = await this.getAccountState();
            return state.accountAlreadyExist;
        } catch (exception) {
            throw new GetActiveStateError(exception.message, exception.stack)
        }
    }

    static async isAccountExists(): Promise<boolean | string> {
        try {
            const state = await this.getAccountState();

            return state.lastUpdatedDate;
        } catch (exception) {
            throw new GetSubscriptionStateError(exception.message, exception.stack)
        }
    }

    static checkNotificationsInBrowserGranted(): boolean {
        return braze.isPushSupported();
    }

    private static async getAccountState(): Promise<ICheckAccountResponse> {
        try {
            console.log('[Notification Service] try to send request on check account');
            const currentUser = CurrentUser.getInstance();
            const requestData = {
                platform: window.app.config.user_browser.name,
                suid: currentUser.getSuid(),
                signature: currentUser.getAuthToken()
            };
            const notificationsApi = new NotificationsApi(Url.getNotificationsServiceUrl());

            return await notificationsApi.checkUserState(requestData);
        } catch (exception) {
            throw new GetAccountStateError(exception.message, exception.stack)
        }
    }
}
